/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { TweenLite } from 'gsap'
import { TransitionGroup, Transition } from 'react-transition-group'
import { bem } from '@argos/utils'
import config from '../Core/Config'
import { MessageContainer, WelcomeHeader, TypingIndicator } from './components'
import { messageIn, messageUserIn, messageSystemIn } from '../Core/Animations'
import { Creators as FormsCreators } from '../Forms/actions'
import { ControlsCreators } from '../actions'

const cn = bem({ prefix: 'lc-', block: 'messages' })
export class Messages extends React.Component {
  static propTypes = {
    agentIsTyping: PropTypes.bool,
    chatStartTime: PropTypes.string,
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        timestamp: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        delay: PropTypes.number.isRequired,
        fileType: PropTypes.string,
        masked: PropTypes.bool,
      }),
    ).isRequired,
  }

  static defaultProps = {
    chatStartTime: '',
  }

  constructor(props) {
    super(props)
    this.state = {
      newMessages: this.props.messages,
    }
  }

  get containerPositionTop() {
    try {
      return this.props.controlsRef.getBoundingClientRect().top
    } catch (error) {
      return null
    }
  }

  handleScroll = () => {
    if (this.messagesRef) {
      TweenLite.to(this.messagesRef, config.formsScrollDuration, { scrollTo: this.messagesRef.scrollHeight })
    }
  }

  handleEnter = (target, type, delay = config.messageDelayFirstRun, isAppearing) => {
    if (!target) {
      return
    }
    const isScrollable = target.getBoundingClientRect().top > this.containerPositionTop
    const onComplete = this.handleScroll
    if (isAppearing) {
      return messageIn({ target, delay: config.messageDelayFirstRun, onComplete })
    }
    if (type === 'user') {
      return messageUserIn({ target, delay, slideIn: !isScrollable, onComplete })
    }
    return messageSystemIn({ target, delay, onComplete })
  }

  render() {
    const {
      chatStartTime,
      messages,
      stage,
      participantName,
      agentIsTyping,
      currentQuestion,
      onSubmit,
      onValidationError,
      complexChange,
    } = this.props
    return (
      <div
        className={cn('')}
        data-test={cn('')}
        ref={(ref) => {
          this.messagesRef = ref
        }}>
        <WelcomeHeader chatStartTime={chatStartTime} />
        <NewMessage
          messages={messages}
          handleEnter={this.handleEnter}
          stage={stage}
          currentQuestion={currentQuestion}
          onSubmit={onSubmit}
          onValidationError={onValidationError}
          complexChange={complexChange}
        />
        <TypingIndicator isTyping={agentIsTyping} participantName={participantName} />
      </div>
    )
  }
}
const NewMessage = ({ messages, handleEnter, stage, currentQuestion, onSubmit, onValidationError, complexChange }) => {
  const [messageCopy, setMessageCopy] = useState(messages)

  useEffect(() => {
    if (messageCopy.length !== 0) {
      setMessageCopy([
        ...messageCopy,
        { ...messages[messages.length - 1], currentQuestion: { ...currentQuestion, selected: false } },
      ])
      return
    }
    setMessageCopy([...messages])
  }, [messages])

  const questionSelected = (id) => {
    const hashId = Math.random()
      .toString(36)
      .substring(2, 7)
    const filteredPill = messageCopy.filter(
      (message) => message && message.currentQuestion && message.currentQuestion.id === id,
    )
    const cp = messageCopy.map((message) => {
      if (message && message.currentQuestion && message.currentQuestion.id === id) {
        filteredPill[0].currentQuestion.id = `${id}${hashId}`
        return { ...filteredPill[0], currentQuestion: { ...filteredPill[0].currentQuestion, selected: true } }
      }
      return message
    })

    setMessageCopy(cp)
  }

  return (
    <TransitionGroup component='ol' exit={false}>
      {messageCopy &&
        messageCopy.map((item, index) => (
          <Transition
            appear={true}
            key={item.timestamp + index}
            timeout={config.messageDuration * 1000}
            onEnter={(node, isAppearing) => handleEnter(node, item.type, item.delay, isAppearing)}>
            {(status) => (
              <MessageContainer
                status={status}
                text={item.text}
                type={item.type}
                name={item.name}
                fileInfo={item.fileInfo}
                masked={item.masked}
                currentQuestion={item.currentQuestion}
                onSubmit={onSubmit}
                onError={onValidationError}
                stage={stage}
                questions={item}
                selected={questionSelected}
                complexChange={complexChange}
              />
            )}
          </Transition>
        ))}
    </TransitionGroup>
  )
}
const mapStateToProps = (state) => ({
  chatStartTime: state.Frame.chatStartTime,
  messages: state.Messaging.messages,
  stage: state.Chat.stage,
  participantName: state.Chat.activeAgentName,
  agentIsTyping: state.Chat.agentIsTyping,
  currentQuestion: state.Forms.currentQuestion,
})

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (answer) => dispatch(FormsCreators.submitAnswer(answer)),
  onValidationError: () => dispatch(FormsCreators.setValidationError()),
  complexChange: (complexState) => dispatch(ControlsCreators.setComplexStage(complexState)),
})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Messages)
